<template>
  <v-container>
    <v-select
      v-model="model"
      :items="priorities"
      item-value="code"
      item-text="name"
      :loading="loading"
    />
  </v-container>
</template>

<script>
export default {
  name: 'PriorityDropdown',
  props: {
    value: {
      type: String
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      priorities: [],
      loading: false
    }
  },
  mounted () {
    this.getPriorities()
  },
  methods: {
    getPriorities () {
      this.loading = true
      this.$_rest.get('/appointment-priorities', undefined, response => {
        this.loading = false
        this.priorities = response.data.filter(active=>active.isActive)
      }, error => {
        this.loading = false
        this.$_notify.error(error)
      }, {
        prefixRoutesWithOrganizationId: false
      })
    }
  }
}
</script>

<style scoped>

</style>
